// apps/client/src/net/handlers/mail.ts (M1-T17) — the HUD Mail badge and the arrival chime follow the patched headers. The mailbox
// flag is a perResident object view: Game.afterPatch already re-runs those updates before this handler.
import { t } from '@whiskerton/content';
import type { NetHandlers } from '../../game/game';
import { unreadMail } from '../../state/slices/mail';
import { useGame } from '../../state/store';

const syncUnread = () => { const s = useGame.getState(); s.mailSetUnread(unreadMail(s.you?.mail ?? [])); };
export const handlers: NetHandlers = {
  events: {
    // The server re-labels a removed or deleted resident's letters (hooks/mail.ts onResidentRemoved) but sends no patch for them:
    // do the same to the open mailbox, so it doesn't keep their name until the next snapshot (M2 playtest).
    'resident.left': (e) => {
      const you = useGame.getState().you;
      if (!you?.mail.some((m) => m.from.kind === 'resident' && m.from.id === e.r)) return;
      useGame.setState({ you: { ...you, mail: you.mail.map((m) => m.from.kind === 'resident' && m.from.id === e.r
        ? { ...m, from: { kind: 'resident' as const, id: null, name: t('common.formerResident') } } : m) } });
    },
  },
  onSnapshot() { syncUnread(); },
  onPatch(patch, game) {
    if (!patch.mail) return;
    syncUnread();
    if (patch.mail.upsert.some((h) => !h.read)) game.sound.sfx('mailOpen');
  },
};
